import { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { PageTitle } from "src/components/generic";
import ConsultantRegistrationForm from "src/components/forms/auth/ConsultantRegistrationForm";
import TopNav from "src/components/navigation/TopNav";


const ConsultantRegistration: FunctionComponent = () => (
    <div>
        <div className="px-3">
            <TopNav />
        </div>
        <div>
            <PageTitle title="Consultant Account Registration" />

            <ConsultantRegistrationForm />
        </div>
        <div className='flex flex-col'>
            <Link to='/auth/login' className='text-primary self-center mb-4'>
                Already Have Account?
            </Link>
        </div>
    </div>
);

export default ConsultantRegistration;